<template>
  <div class="login">
    <p class="error-message">{{ errorMessage }}</p>
    <form @submit.prevent="onSubmitLogin">
      <div class="row">
        <div class="input-field col s12">
          <input
            id="login"
            v-model.trim="login"
            type="text"
            class="validate"
            @input="errorMessage = ''"
          >
          <label for="login">Email</label>
        </div>
      </div>
      <div class="row">
        <div class="input-field col s12">
          <input
            id="password"
            v-model.trim="password"
            type="password"
            class="validate"
            @input="errorMessage = ''"
          >
          <label for="password">Password</label>
        </div>
      </div>
      <button
        class="btn waves-effect waves-light login-button"
        type="submit"
        name="action"
      >
        Login
      </button>
    </form>
  </div>
</template>

<script>
  export default {
    name: "Login",
    data: ()=> ({
      login: '',
      password: '',
      errorMessage: '',
    }),

    methods: {
      async onSubmitLogin (){
        const answer = await this.$store.dispatch('login', {login: this.login, password: this.password});
        if (answer.login) {
          await this.$router.push("/accounts-list");
        } else {
          this.errorMessage = 'Invalid login or password'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login {
    display: flex;
    flex-direction: column;
    margin: auto;
    width: 400px;
  }

  .error-message {
    text-transform: uppercase;
    color: #cc3f55;
    padding-left: .75rem;
    min-height: 22px;
  }

  .login-button {
    margin-left: 10px;
  }
</style>